import React from 'react';

import { Button } from 'app/src/elements/buttons';
import { filterButton } from 'app/src/elements/Pagination/FilterStyles';

export const StatusScopes = {
  ACTIVE: 'active',
  PENDING_REVIEW: 'pending_review',
  DECLINED: 'declined',
  TAX_EXEMPTION_PENDING: 'tax_exemption_pending',
};

const ScopeToggle = ({
  scope, statusScope, setStatusScope, count, label, alwaysShow = false,
}) => {
  if (scope === statusScope) {
    return (
      <Button
        style={filterButton}
        label="Show approved buyers"
        onPress={() => setStatusScope(StatusScopes.ACTIVE)}
      />
    );
  }

  if (!alwaysShow && !count) { return null; }

  return (
    <Button
      style={filterButton}
      label={label}
      onPress={() => setStatusScope(scope)}
    />
  );
};

const StatusScopeButtons = ({
  statusScope, setStatusScope, pendingReviewCount, taxExemptionPendingCount,
}) => (
  <>
    <ScopeToggle
      scope={StatusScopes.PENDING_REVIEW}
      statusScope={statusScope}
      setStatusScope={setStatusScope}
      count={pendingReviewCount}
      label={`Show ${pendingReviewCount} buyers pending review for bidding`}
    />
    <ScopeToggle
      scope={StatusScopes.TAX_EXEMPTION_PENDING}
      statusScope={statusScope}
      setStatusScope={setStatusScope}
      count={taxExemptionPendingCount}
      label={
        `Show ${taxExemptionPendingCount} buyers with tax-exempt proof to review`
      }
    />
    <ScopeToggle
      scope={StatusScopes.DECLINED}
      statusScope={statusScope}
      setStatusScope={setStatusScope}
      alwaysShow
      label="Show declined buyers"
    />
  </>
);

export default StatusScopeButtons;
